import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import Login from "./pages/Login";
import Cart from "./pages/Cart";
import About from "./pages/About";
import Checkout from "./pages/Checkout";
import Profile from "./pages/Profile";
import AdminApp from "./admin/AdminApp";

import { initGA } from "./utils/analytics";
import usePageTracking from "./hooks/usePageTracking";

// Layout with Navbar + automatic page tracking
function MainLayout() {
  usePageTracking(); // ← tracks every route change automatically
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/"             element={<Home />} />
        <Route path="/products"     element={<Products />} />
        <Route path="/products/:id" element={<ProductDetails />} />
        <Route path="/login"        element={<Login />} />
        <Route path="/cart"         element={<ProtectedRoute><Cart /></ProtectedRoute>} />
        <Route path="/checkout"     element={<Checkout />} />
        <Route path="/about"        element={<About />} />
        <Route path="/profile"      element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  // Initialize GA4 once on app load
  useEffect(() => {
    initGA();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Admin — completely separate, no Navbar, no tracking */}
        <Route path="/admin/*" element={<AdminApp />} />

        {/* All customer pages — with Navbar and GA4 tracking */}
        <Route path="/*" element={<MainLayout />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;